import { settingsNavItems } from '../../../pages/settings/settingsNav.js'

/**
 * Settings anchors. One page anchor per `settingsNav` item (seeded, so a new
 * settings page gets an anchor without touching this file), placed on its
 * link in the settings navigation and on its Settings home card, plus the
 * primary actions inside the pages.
 */

/**
 * @param {string} path - A `settingsNav` item path, e.g. `/settings/chart-colors`.
 * @returns {string} Its anchor id, e.g. `settings.chart_colors`.
 */
export function settingsAnchorId(path) {
  return `settings.${path.split('/').pop().replace(/-/g, '_')}`
}

const seededSettingsAnchors = settingsNavItems.map((item) => ({
  id: settingsAnchorId(item.path),
  label: item.label,
  intent: item.description,
  route: item.path,
  minRole: 'admin',
  seededFrom: 'settingsNav',
}))

export const SETTINGS_ANCHORS = [
  ...seededSettingsAnchors,
  { id: 'settings.section_menu', label: 'Settings sections', intent: 'Pick a settings section (narrow screens)', route: '/settings', minRole: 'admin' },
  { id: 'settings.users.invite', label: 'Invite user', intent: 'Invite someone to this organization and choose their role', route: '/settings/users', minRole: 'admin' },
  { id: 'settings.campuses.add', label: 'Add campus', intent: 'Add a campus location and its timezone', route: '/settings/campuses', minRole: 'admin' },
  { id: 'settings.chart_colors.add', label: 'Add color', intent: 'Add a color to the chart palette', route: '/settings/chart-colors', minRole: 'admin' },
  { id: 'settings.annotations.add', label: 'Add annotation', intent: 'Mark an event, holiday or campaign on charts', route: '/settings/annotations', minRole: 'admin' },
  { id: 'settings.ai.weekly_brief', label: 'Weekly brief', intent: 'Turn the weekly AI brief on or off and choose who gets it and when', route: '/settings/ai', minRole: 'admin' },
  { id: 'settings.ai.narrative', label: 'Narrative', intent: 'Set the assistant persona and how the brief is written', route: '/settings/ai', minRole: 'admin' },
  { id: 'settings.subscription.change_plan', label: 'Compare and change plans', intent: 'Upgrade or downgrade your plan', route: '/settings/subscription', minRole: 'owner' },
  { id: 'settings.subscription.manage_billing', label: 'Manage billing', intent: 'Update the card, see invoices or cancel in the Stripe billing portal', route: '/settings/subscription', minRole: 'owner' },
  { id: 'settings.integrations.connect', label: 'Connect', intent: 'Connect Rock RMS or Planning Center to Graphit', route: '/settings/integrations', minRole: 'admin' },
  { id: 'settings.integrations.rock_address', label: 'Rock address', intent: 'Enter your Rock address; Graphit checks the plugin is installed before sending you to Rock to sign in', route: '/settings/integrations', minRole: 'admin', parent: 'settings.integrations.connect' },
  { id: 'settings.integrations.rock_setup', label: 'Set up Rock', intent: 'Finish the guided Rock setup (match campuses, choose measurements), or manage measurements once it is done', route: '/settings/integrations', minRole: 'admin' },
]
